import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-badge-active.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-status-badge-idle.svg";
import { ReactComponent as RestoringImg } from "../../../img/ico-status-badge-commit.svg";
import { ReactComponent as LockedImg } from "../../../img/ico-status-badge-lock.svg";
import { ReactComponent as MigrationImg } from "../../../img/ico-status-badge-migration.svg";
import { ReactComponent as PoweringUpImg } from "../../../img/ico-status-badge-on.svg";
import { ReactComponent as PoweringDownImg } from "../../../img/ico-status-badge-off.svg";
import { ReactComponent as PausedImg } from "../../../img/ico-status-badge-pause.svg";
import { ReactComponent as SuspendImg } from "../../../img/ico-status-badge-stop.svg";
import { ReactComponent as RebootImg } from "../../../img/ico-status-badge-restart.svg";
import { ReactComponent as WaitForLaunchImg } from "../../../img/ico-status-badge-ready.svg";
import { ReactComponent as SavingImg } from "../../../img/ico-status-badge-sleep.svg";
import { ReactComponent as NotRespondingImg } from "../../../img/ico-status-badge-no-response.svg";
import { ReactComponent as UnknwonImg } from "../../../img/ico-status-badge-unknown.svg";



import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { DropdownType } from "../../base/CustomDropdown";
import ContainerClusterTemplateAdd from "./ClusterTemplateAdd";
import { parseLocaleDatetime } from "common/util";

export interface ClusterTemplateData {
    container_cluster_template_id: string,
    container_cluster_template_name: string,
    container_cluster_template_description: string,
    insecure_registry_address: string|null,
    http_proxy_address: string|null,
    https_proxy_address: string|null,
    no_proxy_address: string|null,
    floating_ip_yn: boolean,
    tls_yn: boolean,
    labels: string|null,
    master_load_balancer_yn: boolean,
    volume_size_gb: number,
    server_type_code: string,
    private_registry_yn: boolean,
    api_server_port: number,
    network_driver_type_code: string,
    storage_driver_type_code: string,
    coe_type_code: string,
    dns_nameservers: string,
    vm_key_pair: {
      vm_key_pair_id: string,
      vm_key_pair_name: string
    },
    vm_key_pair_name: string,
    network: {
      network_id: string,
      network_name: string,
      external_yn: boolean
    } | null,
    fixed_subnet: {
      subnet_id: string,
      subnet_name: string,
      cidr: string
    } | null,
    fixed_network: {
      network_id: string,
      network_name: string,
      external_yn: boolean
    } | null,
    master_vm_type: {
      vm_type_id: string,
      vm_type_name: string,
      host_cluster_type_code: string,
      share_type_code: string,
      vcpu_count: number,
      memory_capacity_mb: number,
      root_disk_capacity_gb: number,
      ephemeral_disk_capacity_gb: number,
      swap_disk_capacity_mb: number,
      rx_tx_factor: number,
      gpu_available_yn: boolean
    },
    vm_type: {
      vm_type_id: string,
      vm_type_name: string,
      host_cluster_type_code: string,
      share_type_code: string,
      vcpu_count: number,
      memory_capacity_mb: number,
      root_disk_capacity_gb: number,
      ephemeral_disk_capacity_gb: number,
      swap_disk_capacity_mb: number,
      rx_tx_factor: number,
      gpu_available_yn: boolean
    },
    vm_image: {
      vm_image_id: string,
      vm_image_name: string
    },
    vm_image_name: string,
    container_cluster_count: number,
    project: {
      project_id: string,
      project_name: string
    },
    create_ts: string,
    update_ts: string
}

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("CONTAINER_CLUSTER_TEMPLATE_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "CLUSTER_TEMPLATE_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "CLUSTER_TEMPLATE_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "CLUSTER_TEMPLATE_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("CONTAINER_CLUSTER_TEMPLATE_NAME_TEXT"),
        accessor: "container_cluster_template_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("VOLUME_SIZE_TEXT"),
        accessor: "volume_size_gb",
        disableSortBy: false,
        style: {
            width: "70px",
            paddingLeft: "10px"
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText, paddingLeft: 10}}>{value}GB</div>
        )
    },
    {
        Header: i18n.t("CONTAINER_CLUSTER_COUNT_TEXT"),
        accessor: "container_cluster_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.blueText}}>{value}</div>
        )
    },
    {
        Header: i18n.t("KEY_PAIR_NAME_TEXT"),
        accessor: "vm_key_pair_name",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: i18n.t("EXTENRAL_NETWORK_TEXT"),
        accessor: "network.network_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: i18n.t("FIXED_NETWORK_TEXT"),
        accessor: "fixed_network",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value && value.network_name}</div>
        )
    },
    {
        Header: i18n.t("FIXED_SUBNET_TEXT"),
        accessor: "fixed_subnet",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value && value.subnet_name}</div>
        )
    },
    {
        Header: i18n.t("MASTER_VM_TYPE_TEXT"),
        accessor: "master_vm_type.vm_type_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: i18n.t("NODE_VM_TYPE_TEXT"),
        accessor: "vm_type.vm_type_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: i18n.t("VM_IMAGE_TEXT"),
        accessor: "vm_image_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: "project.project_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
];


export const clusterTemplateAddModalContent = {
    title: i18n.t("CONTAINER_CLUSTER_TEMPLATE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <ContainerClusterTemplateAdd />,
}

export const clusterTemplateUpdateModalContent = {
    title: i18n.t("CONTAINER_CLUSTER_TEMPLATE_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: false,
            confirmButtonText: i18n.t("CONFIRM_TEXT")
        },
    ],
    //innerComponent: <HostClusterAdd />,
}

export const hostClusterType:DropdownType[] = [
    {
        value: "NRM",
        label: i18n.t("NORMAL_TYPE_TEXT")
    },
    {
        value: "CMP",
        label: i18n.t("COMPUTE_TYPE_TEXT")
    },
    {
        value: "MEM",
        label: i18n.t("MEMORY_TYPE_TEXT")
    },
    {
        value: "GPU",
        label: i18n.t("GPU_TYPE_TEXT")
    },
]

const className = {
    statusContainer: {
        width: 56,
        display: "flex", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    nameTextContainer: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    blueContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    statusImg: {
        marginRight: 3
    },
}